// Both production hosts have their own registered OAuth callbacks.
export function socialCallbackUrl(provider, currentOrigin, configuredCallback) {
  const origin = new URL(currentOrigin);
  const url = new URL(configuredCallback || '/auth/social-callback', origin);
  const productionHosts = ['vidyakasam.com', 'www.vidyakasam.com'];
  if (origin.protocol === 'https:' && productionHosts.includes(origin.hostname) &&
      productionHosts.includes(url.hostname)) {
    url.protocol = origin.protocol;
    url.host = origin.host;
  }
  url.searchParams.set('provider', provider);
  return url.href;
}
